import { ApostleClass } from '@apeiron/apostle'
import { FetchJsonProps, useReactQueryFetchJson } from '@apeiron/temp'
import ENV_CONFIG from '@src/config'
import useMakeApostle from '@src/deserialize/hook/useMakeApostle'
import * as R from 'ramda'

const useFetchApostleClassesJson = (props?: FetchJsonProps) => {
  const { fetchNow } = props || {}

  const { makeApostleClass } = useMakeApostle()

  return useReactQueryFetchJson<ApostleClass[]>({
    fetchNow,
    path: ENV_CONFIG.JSON_FILE_NAME.APOSTLE,
    deserialize: response => {
      return R.isNotNil(response)
        ? response.map((data: any) => makeApostleClass(data.class))
        : null
    }
  })
}

export default useFetchApostleClassesJson
